__turbopack_context__.v({
  "active": "Stepper-module__-kb4LG__active",
  "complete": "Stepper-module__-kb4LG__complete",
  "connector": "Stepper-module__-kb4LG__connector",
  "indicator": "Stepper-module__-kb4LG__indicator",
  "label": "Stepper-module__-kb4LG__label",
  "root": "Stepper-module__-kb4LG__root",
  "step": "Stepper-module__-kb4LG__step",
  "trigger": "Stepper-module__-kb4LG__trigger",
});
